import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from "react-router-dom";
import {SvgNew, SvgVolta, SvgDelete} from '../Svg.js';

function FormClienteEquipamentos() {
  const [clientes, setClientes] = useState([]);
  const navigate = useNavigate(); // Inicialize o hook
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); 


  const handleNew = async () => {
    const resposta = window.prompt("Digite o novo HD:");
    if (resposta) {
      try {
        const response = await fetch(`http://www.criar.com.br:3000/clienteequipamentosnovo`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            Id: id, // Substitua pelo valor real
            HD: resposta// Substitua pelo valor correto
          }),
        });
        //alert(response.status);
        if (response.status === 200) {
          //const data = await response.text();
          //alert(data);
          navigate(0);
        } else {
          alert('Erro ao INCLUIR PC.'+response.status);
        }
      } catch (error) {
        alert('Erro no servidor.', error);
      }
    }
  };  
  
  const handleDelete = async (ordem, id) => {
      const resposta = window.confirm("Exclur o HD: "+ordem+"?");
      if (resposta) {
          console.log("Usuário escolheu SIM!");
      } else {
          console.log("Usuário escolheu NÃO!");
      }
    try {
      const response = await fetch(`http://www.criar.com.br:3000/clienteequipamentosdelete`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          Id: id, 
          Ordem: ordem
        }),
    });
      //alert(response.status);
      if (response.status === 200) {
        //const data = await response.text();
        //alert(data);
        navigate(0);
      } else {
        alert('Erro ao deletar cliente.'+response.status);
      }
    } catch (error) {
      alert('Erro no servidor.', error);
      
    }
        }

  useEffect(() => {

      fetch(`http://www.criar.com.br:3000/clienteequipamentos?id=${id}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Erro na resposta da API');
          }
          return response.json();
        })
        .then((data) => setClientes(data.ClienteEqu))
        .catch((error) => console.error('Erro ao buscar os dados:', error));
  }, [id]); 
  return (
    
       <div id = "texto2"> 
       <p>Cliente: {id}</p>
       <a href="#New" onClick={() => handleNew()}><SvgNew/></a>
       <a href='/area'><SvgVolta/></a>
      
      <table class="tableGrid">
        <thead>
          <tr>
            <th>Ordem</th>
            <th>HD</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {clientes.map((cliente) => (
            <tr key={cliente.Ordem}>
              <td>{cliente.Ordem}</td>
              <td>{cliente.HD}</td>
              <td>
              &nbsp;&nbsp;<a href="#Aqui" onClick={() => handleDelete(cliente.Ordem, cliente.Id)}><SvgDelete/></a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
            
    </div>
  );
}

export default FormClienteEquipamentos;